export function isFullscreen() {
  return typeof document !== 'undefined' && Boolean(document.fullscreenElement)
}

export async function enterFullscreen() {
  if (typeof document === 'undefined' || !document.documentElement.requestFullscreen) return false
  try { await document.documentElement.requestFullscreen(); return true } catch { return false }
}

export async function exitFullscreen() {
  if (typeof document === 'undefined' || !document.exitFullscreen || !document.fullscreenElement) return false
  try { await document.exitFullscreen(); return true } catch { return false }
}

export async function toggleFullscreen() {
  return isFullscreen() ? exitFullscreen() : enterFullscreen()
}
